/**
 * Query keys of the flight-delay reads (U1). Hierarchical under the existing
 * `['cases', urn, …]` / `['disruptions', urn, …]` trees, so a targeted invalidation
 * of a case or a disruption still reaches them. One module so the hooks, the WS merge
 * (`merge.ts`) and the declare/load writes can never disagree on a key.
 */

/** One case's delay timeline — `ICaseFlightDelay | null` (null = no timeline, a 404). */
export function caseDelayKey(caseUrn: string): readonly unknown[] {
  return ['cases', caseUrn, 'delay'] as const;
}

/** A disruption's delay timelines — `ICaseFlightDelay[]` (the header badge + flight picker). */
export function disruptionDelaysKey(disruptionUrn: string): readonly unknown[] {
  return ['disruptions', disruptionUrn, 'delays'] as const;
}

/** One case's delay-care entitlements (wallet, AIRPORT_OPERATOR+) — `ICareEntitlementView[]`. */
export function careEntitlementsKey(caseUrn: string): readonly unknown[] {
  return ['cases', caseUrn, 'care-entitlements'] as const;
}

/** Predicate segment shared by every case's entitlements key (for a CareChanged sweep). */
export const CARE_ENTITLEMENTS_SEGMENT = 'care-entitlements';

/**
 * A case's sub-cases (PNR groups) — the key `lib/sub-cases/api.ts` `useSubCasesForCase`
 * reads under. A release moves groups out of the delay stamp, so it marks this stale.
 */
export function caseSubCasesKey(caseUrn: string): readonly unknown[] {
  return ['cases', caseUrn, 'sub-cases'] as const;
}
